import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/comentarios/comentarios";
import coments from "../../models/coments/coments";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    newComment: {},
    deleteItem: {},
    editItems: {},
    comment: [],
    openDelete: false,
  },
  mutations: {
    setNewComment(state, data) {
      state.newComment = data;
    },
    setItemDelete(state, data) {
      state.deleteItem = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setEdit(state, options) {
      state.editItems = options;
    },
    setComment(state, data) {
      state.comment = data;
    },
  },
  actions: {
    async getComment(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getComent();

          state.commit("setComment", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async addComment(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.new(state.state.newComment).then((data) => {
            let options = state.state.comment;

            let newItem = coments.fromJson({
              comentId: data.data.comentId,
              comentario: data.data.comentario,
              codAplica: data.data.codAplica,
            });

            options.unshift(newItem);
            state.commit("setComment", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.editItems);

          const updatedItem = state.state.editItems;
          let comments = state.state.comment.map((option) => {
            if (option.comentId !== updatedItem.comentId) {
              return option;
            }
            return coments.fromJson({
              comentId: updatedItem.comentId,
              comentario: updatedItem.comentario || option.comentario,
              codAplica: updatedItem.codAplica || option.codAplica,
            });
          });

          state.commit("setComment", comments);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.deleteItem);

          let options = state.state.comment.filter(
            (option) => option.comentId !== state.state.deleteItem
          );

          state.commit("setComment", options);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
